import {Button, notification} from 'antd';
import {stashRedirectPath} from 'utils/autoLogin';
import {LOGIN_SUCCESS_EVENT, openLoginPopup} from 'utils/loginPopup';

export const SESSION_EXPIRED_RECONNECT_KEY = 'session-expired-reconnect';

export const reconnect = () => {
  notification.destroy(SESSION_EXPIRED_RECONNECT_KEY);
  // Preserve the page in case the popup is blocked and we have to fall back
  // to a full-page redirect.
  stashRedirectPath();
  openLoginPopup({fallbackMode: 'always'});
};

export const showSessionExpiredPrompt = () => {
  const dismiss = () => notification.destroy(SESSION_EXPIRED_RECONNECT_KEY);

  window.addEventListener(LOGIN_SUCCESS_EVENT, dismiss, {once: true});

  notification.warning({
    key: SESSION_EXPIRED_RECONNECT_KEY,
    message: 'Session expired',
    description:
      'Your session has expired. Reconnect to keep your unsaved work.',
    duration: 0,
    btn: (
      <Button type="primary" size="small" onClick={reconnect}>
        Reconnect
      </Button>
    ),
    onClose: () => window.removeEventListener(LOGIN_SUCCESS_EVENT, dismiss),
  });
};
